"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const generic_entity_1 = require("./generic-entity");
/**
 * This client is generic and not associated with a specific entity but rather provides support for a platform feature area.
 * A client is a Nblocks Block feature area
 */
class Client extends generic_entity_1.Entity {
}
exports.Client = Client;
